import { bool, func, number, object, oneOf, string } from 'prop-types'
import { Component } from 'react'
import { getEditorColors } from '@opallabs/hubble/src/Helpers/textEditorHelper'
import { getThemeStyles } from '@opallabs/hubble/src/Helpers/themeHelper'
import { kuiperClassNames, DraftJSEditor } from '@opallabs/kuiper'
import Slide from '../Slide'

import './styles.scss'

class TextSlide extends Component {
  static propTypes = {
    backgroundImageURL: string,
    getSlide: func,
    htmlText: string,
    layout: oneOf(['basic_text', 'section_header']).isRequired,
    presentationId: number,
    slideId: number,
    theme: object,
    updateSlide: func,
    viewOnlyMode: bool,
  }

  static defaultProps = {
    theme: {},
    updateSlide: () => {},
  }

  constructor(props) {
    super(props)
    this.state = {}
  }

  onChange = (changes) => {
    this.props.updateSlide(
      this.props.presentationId,
      this.props.slideId,
      changes
    )
  }

  get customStyles() {
    const themeStyles = getThemeStyles(this.props.theme, [
      'bodyFontColor',
      'bodyFontFamily',
    ])
    const borderColor = getEditorColors(this.props.theme).borderColor
    const hoverColor = getEditorColors(this.props.theme).backgroundColor

    return { ...themeStyles, borderColor, hoverColor }
  }

  get defaultTextFormat() {
    switch (this.props.layout) {
      case 'basic_text':
        return {
          alignmentStyle: 'left',
          paragraphStyle: 'p',
        }
      case 'section_header':
        return {
          alignmentStyle: 'center',
          paragraphStyle: 'h1',
        }
      default:
        break
    }

    return null
  }

  render() {
    return (
      <div className={kuiperClassNames('text-slide')}>
        <Slide
          backgroundImageURL={this.props.backgroundImageURL}
          getSlide={this.props.getSlide}
          presentationId={this.props.presentationId}
          slideId={this.props.slideId}
          theme={this.props.theme}
          customClassName={kuiperClassNames(this.props.layout)}
        >
          <DraftJSEditor
            ariaLabel="Presentation Slide Text"
            entityType="slide"
            htmlText={this.props.htmlText}
            saveEditorState={this.onChange}
            saveOnChange={true}
            customStyles={this.customStyles}
            viewOnlyMode={this.props.viewOnlyMode}
            defaultTextFormat={this.defaultTextFormat}
            floatingControls={true}
            verticalTextAlignment="center"
            theme="dark-presentation"
          />
        </Slide>
      </div>
    )
  }
}

export default TextSlide
